import { graphql } from "@/graphql/generated/gql";

export const municipalPropertyListQueryDocument = graphql(/* GraphQL */ `
  query MunicipalPropertyList($input: MunicipalPropertyListInput!) {
    municipalPropertyList(input: $input) {
      nodeList {
        id
        name
        type
        description
        street
        houseNumber
        postalCode
        city
        usableFloorAreaM2
        commissioningYear
        archivedAt
        updatedAt
        municipalityList {
          id
          name
        }
      }
      endCursor
      hasNextPage
      totalCount
    }
  }
`);
